import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import AccountMenu from '../../Modules/AccountMenu'
import BijeenkomstNew from '../../Modules/Kennis/Toevoegen/BijeenkomstNew'

import RefferalSearch from '../../Modules/Kennis/Toevoegen/RefferalSearch'
import RegularSearchYear from '../../Modules/Kennis/Toevoegen/RegularSearchYear'

class MemberBijeenkomstAdd extends Component {
  constructor(props) {
    super(props)
    this.onUpdate = this.onUpdate.bind(this)
    this.state = {
      year: 2019,
      course: 0,
      errors: {}
    }
  }
  onUpdate = (name, value) => {
    this.setState({
      [name]: value
    })
  }
  render() {
    return (
      <div className="route">
        <AccountMenu />
        <div className="grey-bg">
          <h1 className="pageTitle">
            Een bijeenkomst toevoegen
            </h1>
          <Row>
            <Col md={6} sm={6}>
              <h4>Zoek op referentie nummer</h4>
              <hr />
              <RefferalSearch onUpdate={this.onUpdate} />
            </Col>
            <Col md={6} sm={6}>
              <h4>Regulier zoeken</h4>
              <hr />
              <RegularSearchYear onUpdate={this.onUpdate} />
            </Col>
          </Row>
          <hr />
          <Row>
            <Col mdPush={2} md={8}>
              <BijeenkomstNew year={this.state.year} course={this.state.course} /><br /><br />
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <p className="text-right"><Link to="/kennis/onbekende-bijeenkomst/toevoegen">Staat jouw bijeenkomst er niet bij? voeg er een toe!</Link></p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default MemberBijeenkomstAdd;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/Bijeenkomst.js